export const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    slidesToSlide: 3 // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    slidesToSlide: 2 // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1 // optional, default to 1.
  }
};

export const services = [
  'CARPET-CLEANING',
  'UPHOLSTERY-CLEANING',
  'MATTRESS-CLEANING',
  'MAINTENANCE',
  'URINE-PET-ODOUR-REMOVER',
  'COMMERCIAL-CARPET-CLEANING',
  'HARD-FLOOR-CLEANING',
  'END-OF-TENANCY-CLEANING',
  'HOLIDAY-LET-CLEANING'
];

export const facebookReviewsData = [
  {
    message: 'Excellent professional service. Carpets came up like new. George worked very hard was friendly and completed the job in time, would definitely recommend again',
    author: 'A.B.',
    rating: 5
  },
  {
    message: 'Excellent service all round ,with outstanding results, 100% better than any other service we have used previously. Exceptionally polite, accommodating and genuine guy. I would highly recommend.',
    author: 'K.L.',
    rating: 5
  },
  {
    message: 'I highly recommend. 5 star professional service from start to finish. Enquired about stair carpets being cleaned and was here the next day doing the job. The service provided was outstanding!! What an asset to have such a great small business on our doorstep. I’m very happy with the job that was done. Excellent!',
    author: 'J.G.',
    rating: 5
  },
  {
    message: 'George was so professional from the minute he arrived until the job was completed! He has done an amazing job cleaning our rooms and stairs. Nearly better than brand new! Highly recommend and dare say we shall be using again in the future! Five Stars ⭐⭐⭐⭐⭐',
    author: 'J.F.',
    rating: 5
  },
  {
    message: 'George spent most of the day making a fantastic job cleaning 2 x Sofas - 1 winged chair -1 rug - 2 bedroom carpets and my workroom. He kept me informed on every aspect of his work. Excellent results on very stubborn stains. 5 ☆☆☆☆☆ service. Definitely recommend. Thank you George.',
    author: 'M.K.',
    rating: 5
  },
  {
    message: 'Georghe spent most of the day cleaning all the carpets and rugs (some delicate) as we just moved into our new house. He did a great job, very thorough and results were exceptional. He is also a very friendly polite guy and takes pride in his work. Thoroughly recommend the firm. Thanks Georghe !',
    author: 'I.P.',
    rating: 5
  },
  {
    message: 'George came out to ours today to clean all of our downstairs carpets and our staircase carpet. The difference is night and day!!! Absolutely thrilled with the results. George is so hardworking and a pleasure to deal with. Highly recommend! 10 out of 10 😊',
    author: 'C.M.',
    rating: 5
  },
  {
    message: 'George cleaned our carpets today, oh my goodness, the results... incredible! Amazing service from start to finish 🌟 I will definitely recommend George to everyone!',
    author: 'L.F.',
    rating: 5
  },
  {
    message: 'Wow Gheorghe did a fantastic job of the lounge carpet, it was stained with tea and had endured a year of traffic from two big dogs, you’d never have known this after Gheorghe had finished! 👌🏻perfect job. Will highly recommend. 5 🌟 Thank you.',
    author: 'A.L.',
    rating: 5
  },
  {
    message: 'George was great , came and proved the job up , arrived early , worked very professionally and tidy and all the furniture he treated and cleaned looks and smells like new ! Would highly recommend , thanks George',
    author: 'C.M.',
    rating: 5
  },
  {
    message: 'Wow!!! What a fantastic job. I was not sure what to expect as we had building work done and carpets were not in a good state….I couldn’t believe the difference, they look brand new, Gheorghe (George) was so kind and respectful, I would have no hesitation in recommending him or his services',
    author: 'N.M.',
    rating: 5
  },
  {
    message: 'Gheorghe cleaned all the carpets in my property. He did an excellent job. He communicated well prior to arrival, turned up on time, was very personable, and worked very hard. Couldn’t ask for more. Thanks Gheorghe.',
    author: 'B.A.',
    rating: 5
  },
  {
    message: 'Absolutely fantastic job!!! What a change to our house.. no need to replace the carpets now! George was quick, efficient and so pleasant. 5 star review 🙏',
    author: 'D.D.',
    rating: 5
  },
  {
    message: 'George done an amazing job on our carpets in the hallway and conservatory,  would highly recommend to anyone wanting there\'s done',
    author: 'L.M.',
    rating: 5
  },
  {
    message: 'George provides a very professional and friendly service and gave brilliant advice on our carpets and sofa upholstery. He has done a fantastic job on our carpets, what a difference, they look amazing!✨🤩 we have wee ones so it’s great to know that all the cleaning chemicals are non-toxic and eco-friendly🌱👶👣 Thank you so much George, looking forward to your help for our future cleaning requirements!🫧',
    author: 'L.G.',
    rating: 5
  },
  {
    message: 'I called Georgi yesterday and after discussion on what I required, he was out 1st thing this morning. That\'s servive right out the gate! Company is 100% professional and courteous. Georgi even helped me moved my furniture around to allow him access to clean the carpets. They have come up better than new. I\'ve no hesitation in recommending Georgi. Get him booked!!! You won\'t regret it. Satisfaction guarenteed 👍',
    author: 'J.S.',
    rating: 5
  }
]